import { fadeOutNotifications } from '../functions';


$(document).ready(function() {

    $(document).on('click', '#apply-coupon', function(e) {
        e.preventDefault();

		$('#cart-page-notifications').html('');
        $('#coupon-code').removeClass('is-invalid');

		if($('#coupon-code').val() == '') {
            $('#coupon-code').addClass('is-invalid');
            return false;
        }

        var values = '_token=' + $('#_token_page_cart').val();
        values += '&code=' + $('#coupon-code').val();
		$.ajax({
            type: "POST",
            url: baseURL + "/cart/apply-coupon",
            data: values,
            success: function(response) {
                if (response.status == 0) {
					$('#cart-page-notifications').html('<div class="errors-wrapper"><p>'+response.message+'</p></div>');
					fadeOutNotifications('#cart-page-notifications .errors-wrapper');
                    return false;
                }

                if (response.status == 1) {
					$('#cart-page-notifications').html('<div class="success-wrapper"><p>'+response.message+'</p></div>');
					fadeOutNotifications('#cart-page-notifications .success-wrapper');

					let html = '<div class="cart-coupon-code">'+response.coupon.code+' <span class="cart-coupon-value">'+response.coupon.discount_value+response.coupon.discount_symbol+'</span></div>';
					html += '<div class="cart-coupon-clear-wrapper"><a href="javascript:void(0)" id="remove-coupon">Remove</a></div>';
					$('.coupon-wrapper').html(html);

					$('.cart-page-main-total-amount').html(response.total);

                    return false;
                }

				$('#cart-page-notifications').html('<div class="errors-wrapper"><p>'+response.message+'</p></div>');
				fadeOutNotifications('#cart-page-notifications .errors-wrapper');
				return false;
            },
            error(error) {

            }
        });
    });

	$(document).on('click', '#remove-coupon', function(e) {
        e.preventDefault();

		var values = '_token=' + $('#_token_page_cart').val();
		$.ajax({
            type: "POST",
            url: baseURL + "/cart/remove-coupon",
            data: values,
            success: function(response) {

                if (response.status == 1) {

					let html = ' <div class="input-group"><i class="fa fa-tag" aria-hidden="true"></i>';
					html += '<input type="text" class="form-control" name="coupon-code" id="coupon-code" placeholder="Une code promo? Parainage?"/>';
					html += '<div class="input-group-append"><a href="javascript:void(0)" id="apply-coupon"><span class="input-group-text">OK</span></a></div>';
					html += '</div>';
					$('.coupon-wrapper').html(html);

					$('.cart-page-main-total-amount').html(response.total);

                    return false;
                }

				$('#cart-page-notifications').html('<div class="errors-wrapper"><p>Error: Something went wrong please contact an administrator!</p></div>');
				fadeOutNotifications('#cart-page-notifications .errors-wrapper');
				return false;
            },
            error(error) {

            }
        });
	});
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/coupons.js